import {GradientColor} from './gradientModel';

export function gradientPointColors(gradientString: string): GradientColor {

  const array = gradientString.split(',');
  
  const direction = array[0];

  array.splice(0, 1);
  
  const obj = new GradientColor();

  obj.gradient = [];

  obj.direction = direction;

  array.forEach((item:any)=>{
    console.log(item);
    obj.gradient.push({
      color: item.trim().split(' ')[0],
      position: item.trim().split(' ')[1],
    });
  });

  return obj;
}

export function gradientString(colors: GradientColor): string {
  // console.trace();
  // console.error('??????????', colors);
  let str = '';
  // console.log(colors);
  colors = JSON.parse(JSON.stringify(colors));
  colors.gradient.sort((a: any, b: any) => {
    return parseFloat(a.position.replace('%', '')) - parseFloat(b.position.replace('%', ''));
  });
  colors.gradient.forEach(GradientElement=>{
    str += GradientElement.color + ' ' + GradientElement.position + ',';
  });

  str = str.substring(0, str.length - 1);
  // console.log(colors.direction + ',' + str);
  return `linear-gradient(${colors.direction},${str})`;
}

export function exportGradientString(colors: GradientColor): string {
  let str = '';
  colors.gradient.forEach(GradientElement=>{
    str += GradientElement.color + ' ' + GradientElement.position + ',';
  });
  str = str.substring(0, str.length - 1);
  console.log(colors.direction + ',' + str);
  return `${colors.direction},${str}`;
}
